import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAndLogout } from '../../utils/session';
import { useAuth } from '../../context/authContext';

const Servicios = () => {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();

  const getUserString = () => {
    try {
      const s = sessionStorage.getItem('user') || localStorage.getItem('user') || '';
      if (!s) return authUser?.user || '';
      try {
        const o = JSON.parse(s);
        return (o.user || o.id || o.email || o.usuario || o.username || '') + '';
      } catch (_) { return s + ''; }
    } catch (_) { return ''; }
  };

  const handleVolver = () => navigate('/superadmin');

  useEffect(() => {
    const handlePopState = () => {
      const didLogout = confirmAndLogout(navigate, '/login');
      if (!didLogout) {
        try { window.history.pushState(null, '', window.location.href); } catch (_) {}
      }
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  return (
    <div style={{ ...styles.container, position: 'relative' }}>
      <div style={{ position: 'absolute', top: 12, left: 12, zIndex: 50 }}>
        <button
          onClick={handleVolver}
          style={{
            padding: '10px 22px',
            borderRadius: 20,
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 700,
            fontSize: 15,
            boxShadow: '0 2px 8px rgba(29,78,216,0.35)',
            letterSpacing: '0.3px',
          }}
        >
          ← Volver
        </button>
      </div>

      <h1 style={styles.title}>🧹🧼 Servicios 🧹🧼 <strong style={{ color: '#007bff' }}>{getUserString()}</strong></h1>

      <div style={styles.buttonContainer}>
        {[
          { title: 'Ruta de supervisora', image: '/images/ver-ruta-supervisora.png', path: '/admin/ruta-supervisora' },
          { title: 'Seguimiento Servicios', image: '/images/seguimiento-servicios.jpg', path: '/admin/seguimientoServicios' },
          { title: 'Análisis Asistentas', image: '/images/estadisticas.png', path: '/admin/analisis-asistentas' },
          { title: 'Análisis Supervisoras', image: '/images/estadisticas.png', path: '/admin/analisis-supervisoras' },
          { title: 'Estado de Pisos', image: '/images/estadisticas.png', path: '/admin/analisis-pisos' },
          { title: 'Análisis Alumnos', image: '/images/gestion_usuarios.png', path: '/admin/analisis-alumnos' },
          { title: 'Reportes Diarios', image: '/images/reporte-asistentas.jpg', path: '/admin/reportes-diarios' },
          { title: 'Reporte de Asistentas', image: '/images/reporte-asistentas.jpg', path: '/admin/reporte-asistentas' },
          { title: 'Reporte de Supervisoras', image: '/images/mis-reportes.png', path: '/admin/reporte-supervisoras' },
          { title: 'Organización Ruta 3', image: '/images/organizar-servicios.png', path: '/admin/organizar-ruta-3' },
          { title: 'Configuración Servicios', image: '/images/configuracion.png', path: '/admin/configuracion-servicios' },
        ].map((option) => (
          <button key={option.title} onClick={() => navigate(option.path)} style={styles.button}>
            <img src={option.image} alt={option.title} style={styles.image} />
            <span style={styles.label}>{option.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    minHeight: '100vh',
  },
  title: { marginBottom: '30px', color: '#333', marginTop: 60 },
  buttonContainer: { display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' },
  button: {
    width: '90%', maxWidth: '400px', padding: '20px',
    border: '2px solid #007bff', borderRadius: '10px',
    backgroundColor: 'transparent', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
    gap: '20px', cursor: 'pointer', transition: 'all 0.2s ease-in-out',
  },
  image: { width: '50px', height: '50px', objectFit: 'contain' },
  label: { fontSize: '20px', fontWeight: 'bold', color: '#007bff', textAlign: 'center' },
};

export default Servicios;
